import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Tooltip,
  Typography,
  TableSortLabel,
  colors,
  makeStyles,
} from "@material-ui/core";
import React from "react";

import { NamedTrackerInfo } from "../types";

export type WebTrackerCatalogTableSort = {
  column: "name" | "riskLevel";
  direction: "asc" | "desc";
};

export type WebTrackerCatalogTableProps = {
  trackers: NamedTrackerInfo[];
  sort: WebTrackerCatalogTableSort;
  onSort(column: "name" | "riskLevel"): void;
};

const useStyles = makeStyles((_) => ({
  risklow: {
    backgroundColor: colors.green[100],
  },
  riskmedium: {
    backgroundColor: colors.yellow[100],
  },
  riskunknown: {
    backgroundColor: colors.grey[100],
  },
  riskhigh: {
    backgroundColor: colors.red[100],
  },
}));

function WebTrackerCatalogTable({
  trackers,
  sort,
  onSort,
}: WebTrackerCatalogTableProps) {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={sort.column === "name"}
                direction={sort.direction}
                onClick={() => onSort("name")}
              >
                <Typography variant="h6">name</Typography>
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <Typography variant="h6">description</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">category</Typography>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sort.column === "riskLevel"}
                direction={sort.direction}
                onClick={() => onSort("riskLevel")}
              >
                <Typography variant="h6">riskLevel</Typography>
              </TableSortLabel>
            </TableCell>
            <TableCell style={{ textAlign: "center" }}>
              <Tooltip title="Does this tracker collect PHI?">
                <Typography variant="h6">collectsPHI</Typography>
              </Tooltip>
            </TableCell>
            <TableCell style={{ textAlign: "center" }}>
              <Tooltip title="Will this tracker sign a BAA?">
                <Typography variant="h6">supportsBAA</Typography>
              </Tooltip>
            </TableCell>
            <TableCell>
              <Typography variant="h6">domains</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {trackers.map((t) => (
            <TableRow key={`cataloged-tracker-${t.name}`}>
              <TableCell scope="row">{t.name}</TableCell>
              <TableCell>{t.description}</TableCell>
              <TableCell>{t.category}</TableCell>
              <TableCell className={classes[`risk${t.riskLevel}`]}>
                <small>
                  <pre>
                    <code>{t.riskLevel}</code>
                  </pre>
                </small>
              </TableCell>
              <TableCell>
                <small>
                  <pre>
                    <code>{JSON.stringify(t.collectsPHI)}</code>
                  </pre>
                </small>
              </TableCell>
              <TableCell>
                <small>
                  <pre>
                    <code>{t.supportsBAA}</code>
                  </pre>
                </small>
              </TableCell>
              <TableCell>
                <small>
                  <pre>
                    <code>{t.domains.sort().join(",\n")}</code>
                  </pre>
                </small>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default WebTrackerCatalogTable;
